// facultyData.js

const facultyData = {
  departments: [
    {
      department_name: "School of Health Science & Technology",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Anupama+Moirangthem.jpeg",
          name: "Dr. Anupama Moirangthem",
          post: "Associate Professor & Assistant Dean",
          experience: "12+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Prakash+Chettri.jpeg",
          name: "Mr. Prakash Chettri",
          post: "Assistant Professor & Senior Academic Coordinator",
          experience: "7+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Anumika+Sharma.jpeg",
          name: "Ms. Anumika Sharma",
          post: "Assistant Professor–II (Senior Scale) & Program Coordinator - Department of Medical Laboratory Sciences",
          experience: "4 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Banasmita+Devi.jpeg",
          name: "Ms. Banasmita Devi",
          post: "Assistant Professor",
          experience: "10 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Sajal+Giri+Goswami.jpeg",
          name: "Mr. Sajal Giri Goswami",
          post: " Tutor & Technical Officer–I",
          experience: "5 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Ujjwal+Kumar+Jha.jpeg",
          name: "Mr. Ujjwal Kumar Jha",
          post: "Assistant Professor–II (Senior Scale) & Program Coordinator- Department of Medical Radiology and Imaging Technology",
          experience: "6+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Divya+Rana.jpeg",
          name: "Ms. Divya Rana",
          post: "Assistant Professor–II (Senior Scale)",
          experience: "4+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Divya+Chettri.jpeg",
          name: "Ms. Divya Chettri",
          post: "Assistant Professor",
          experience: "7 Month",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Nekita+Sharma.jpeg",
          name: "Ms. Nekita Sharma",
          post: "Assistant Professor–II (Senior Scale) & Program Coordinator- Department of Emergency Medical Technology (Paramedic)",
          experience: "4+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Jyoshnika+Huzuri.jpeg",
          name: "Ms. Jyoshnika Huzuri",
          post: "Assistant Professor",
          experience: "1 Yr",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Izmir+Gadi.jpeg",
          name: "Ms. Izmir Gadi",
          post: "Assistant Professor",
          experience: "7 Months",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Deepeka+Sharma.jpeg",
          name: "Ms. Deepeka Sharma",
          post: "Nursing Tutor & Academic Coordinator",
          experience: "4+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Meghna+Chettri.jpeg",
          name: "Ms. Meghna Chettri",
          post: "Tutor",
          experience: "4+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Subham+Sarkar.jpeg",
          name: "Mr. Subham Sarkar",
          post: "Assistant Professor–II (Senior Scale) & Program Coordinator- Department of Optometry",
          experience: "6+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Sahanaj+Parveen.jpeg",
          name: "Ms. Sahanaj Parveen",
          post: "Assistant Professor",
          experience: "5+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Nilanjan+Dutta.jpeg",
          name: "Mr. Nilanjan Dutta",
          post: "Assistant Professor",
          experience: "1+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Ravi+Yadav.jpeg",
          name: "Mr. Ravi Yadav",
          post: "Assistant Professor",
          experience: "2+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Abishek+Sharma_.jpg",
          name: "Abishek Sharma",
          post: "Assistant Professor – Dialysis",
          experience: "Fresher",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Arghajyoti+Bhattacharjee.png",
          name: "Mr. Arghyajyoti Bhattacharjee",
          post: "Clinical Instructor & Dialysis Application Specialist–I (Technical)",
          experience: "2+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Anurag+Dahal.jpeg",
          name: "Dr. Anurag Dahal(PT)",
          post: "PIC",
          experience: "4 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Dr.+Rinzing+Choden+Bhutia.jpeg",
          name: "Dr. Rinzing Choden Bhutia (PT)",
          post: "Assistant Professor – Physiotherapy",
          experience: "1 Yr",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Dr.+Neetu+Yadav.jpeg",
          name: "Dr. Neetu Yadav",
          post: "Assistant Professor",
          experience: "6.5 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Dr.+Meghna+Pradhan.jpeg",
          name: "Dr. Meghna Pradhan (PT)",
          post: "Assistant Professor",
          experience: "",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Aniruddha+Sen.jpeg",
          name: "Aniruddha Sen",
          post: "Assistant Professor",
          experience: "",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Nashit+Saleha.jpeg",
          name: "Dr. Nashit Saleha",
          post: "Assistant Professor - Hospital Administration",
          experience: "",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Anmol+Luitel.jpeg",
          name: "Anmol Luitel",
          post: "Adjunct Faculty - Dialysis",
          experience: "",
        },
        // {
        //   image:
        //     "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Debasrita+Banerjee.jpeg",
        //   name: "Mr. Debasrita Banerjee",
        //   post: "Assistant Professor",
        //   experience: "7+ Yrs",
        // },
      ],
    },
    {
      department_name: "School of Computer Science & Engineering",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Dr-Raghavendra-Prasad.webp",
          name: "Dr. Raghavendra Prasad",
          post: "Professor & Associate Dean",
          experience: "19 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Pappumoni+Bordoloi.jpeg",
          name: "Mr. Pappumoni Bordoloi",
          post: "Assistant Professor-II (Senior Scae) & HOD, Department of Information Technology",
          experience: "8+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Digendra+Rai.jpeg",
          name: "Mr. Digendra Rai",
          post: "Assistant Professor-II (Senior Scale) & Head, Industry Integration",
          experience: "8 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Nawang+Lama.jpeg",
          name: "Mr. Nawang Lama",
          post: "Assistant Professor-III (Selected Grade) & HOD,Deaprtment of Computer Science  & Engineering",
          experience: "14+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Tek+Bahadur+Chettri.jpeg",
          name: "Mr. Tek Bahadur Chettri",
          post: "Master Skill Instructor",
          experience: "9+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Sachin+Kumar+Sharma.jpeg",
          name: "Mr. Sachin Kumar Sharma",
          post: "Skill Instructor",
          experience: "2 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Pritam+Kumar+Bhagat.jpeg",
          name: "Mr. Pritam Kumar Bhagat",
          post: "Skill Instructor",
          experience: "3+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Rohan+Dhakal.jpg",
          name: "Rohan Dhakal",
          post: "Computer Lab Instructor - School of Computer Science and Engineering",
          experience: "Fresher",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Roshan+Chhetri.jpeg",
          name: "Roshan Chhetri",
          post: "Skill Instructor",
          experience: "",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Bibek+Chettri.jpeg",
          name: "Bibek Chettri",
          post: "Adjunct Faculty - Physic",
          experience: "",
        },
      ],
    },
    {
      department_name: "School of Management & Commerce",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/M+Jamal.jpeg",
          name: "Mr. Mohammad Jamal",
          post: "Assistant Professor - Assistant Dean",
          experience: "20+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Mohammed+Parvesh.jpeg",
          name: "Mr. Mohammed Parvesh",
          post: "Master Skill Instructor, Head - Industry Integration",
          experience: "15 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/MATRIKA+PRASAD+SHARMA.jpeg",
          name: "Mr. Matrika Prasad Sharma",
          post: "Assistant Professor",
          experience: "13 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Snehasish+Bhattacharjee.jpeg",
          name: "Mr. Snehasish Bhattacharjee",
          post: "	Master Skill Instructor & Coordinator – Professional Upskilling",
          experience: "18 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Debarshee+Guha.jpeg",
          name: "Mr. Debarshee Guha",
          post: "Master Skill Instructor",
          experience: "14 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Sudan+Gurung.png",
          name: "Mr. Sudan Gurung",
          post: "Master Skill Instructor",
          experience: "9 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Aditya+Prakash.PNG",
          name: "Mr. Aditya Prakash",
          post: "Sr. Skill Instructor",
          experience: "2.5 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Subham+Kumar+Jana.jpeg",
          name: "Mr. Subham Kumar Jana",
          post: "Skill Instructor",
          experience: "11 Yrs",
        },
      ],
    },
    {
      department_name: "School of Hospitality & Tourism",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/James+Sarungbam.jpeg",
          name: "Mr. James Sarungbam",
          post: "Head Of the Department",
          experience: "16 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Bidisha+Roy.jpg",
          name: "Bidisha Roy",
          post: "Assistant Professor – Food and Beverage Services",
          experience: "13 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Ms.+Rapti+Chatterjee.jpeg",
          name: "Rapti Chatterjee",
          post: "Assistant Professor - Food Production",
          experience: "",
        },
      ],
    },
    {
      department_name: "School of Pharmacy",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Dr-Sanaul-Mustafa.jpg",
          name: "Dr. Sanaul Mustafa",
          post: "Principal",
          experience: "15 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Ambika+Sharma.jpeg",
          name: "Ms. Ambika Sharma",
          post: "Assistant Professor",
          experience: "3+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Divya+Pradhan.jpeg",
          name: "Ms. Divya Pradhan",
          post: "Assistant Professor",
          experience: "2+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Grace+Pradhan.jpeg",
          name: "Ms. Grace Pradhan",
          post: "Lab Technician",
          experience: "3.5 Yrs",
        },
      ],
    },
    {
      department_name: "College of Nursing",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Dr.+B+Chetan+Kumar+Photo.png",
          name: "Dr. B Chetan Kumar",
          post: "Principal - Medhavi College of Nursing",
          experience: "14 Yrs 6 Months",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Ws+Jyoti+Anal.jpeg",
          name: "Ms. Ws Jyoti Anal",
          post: "Assistant Professor",
          experience: "8.5 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Jemimah+Rai.jpeg",
          name: "Ms. Jemimah Rai",
          post: "Tutor",
          experience: "2.6 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Prasansha+Rani+Chhetri.jpeg",
          name: "Ms. Prasansha Rani Chhetri",
          post: "Tutor",
          experience: "2 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Sevika+Chettri.webp",
          name: "Ms. Sevika Chettri",
          post: "Tutor",
          experience: "3+ Yrs",
        },
      ],
    },
    {
      department_name: "School of Humanities",
      faculty: [
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Avijit+Chakraborty.jpeg",
          name: "Mr. Avijit Chakraborty",
          post: "Assistant Professor",
          experience: "13 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Priti+Thapa.jpeg",
          name: "Ms. Priti Thapa",
          post: "Assistant Professor",
          experience: "12 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Charles+Elvin+Darjee.jpeg",
          name: "Mr. Charles Elvin Darjee",
          post: "Assistant Professor",
          experience: "1+ Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Seema+Shruti.jpeg",
          name: "Ms. Seema Shruti",
          post: "Sr. Skill Instructor",
          experience: "7 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Urbashi+Gahatraj.jpeg",
          name: "Ms. Urbashi Gahatraj",
          post: "Skill Instructor",
          experience: "2.5 Yrs",
        },
        {
          image:
            "https://cdn.msu.edu.in/msu-reavamp/images/our-faculty/Kaveri+Rai.jpeg",
          name: "Ms. Kaveri Rai",
          post: "Skill Instructor",
          experience: "4 Yrs",
        },
      ],
    },
  ],
};

export default facultyData;